import { URL } from "@/constants/Buyer";
import { PER_PAGE_BUYER_PAGINATION } from "@/views/buyer/constants/BuyerPagination";
import removeDuplicateObjectApi from "@/helpers/removeDuplicateObjectApi";
import { filterPackageInMobile } from "@/helpers/packageHelper";
import api from "axios";

export const setFavorite = async (vehicleId) => {
  return api
    .post(`/purchasers/evaluation/favorite/${vehicleId}`)
    .then((response) => response.data)
    .catch((error) => `setFavorite ${error}`);
};

export const details = async (params = []) => {
  return api
    .get(`/purchasers/dashboard/counts`, { params })
    .then((response) => response.data.payload)
    .catch((error) => `details ${error}`);
};

export const countsLeftMenu = async () => {
  return api
    .get(`/purchasers/counts`)
    .then((response) => response.data.payload)
    .catch((error) => `countsLeftMenu ${error}`);
};

export const getPaymentPeding = async (orderBy = null) => {
  const order = orderBy === "" ? null : orderBy;

  return api
    .get(`/purchasers/side/pending/boletos`, {
      params: {
        order,
      },
    })
    .then((response) => {
      const payload = response.data.payload;
      if (!payload.pendentes || (Array.isArray(payload) && payload.length === 0)) {
        return [];
      }
      return payload.pendentes.boletos;
    })
    .catch((error) => `getPaymentPeding ${error}`);
};

export const getBidPending = async (orderBy = null) => {
  const order = orderBy === "" ? null : orderBy;

  return api
    .get(`/purchasers/side/pending/sob_aprovacao`, {
      params: {
        order,
      },
    })
    .then((response) => {
      const payload = response.data.payload;
      if (!payload.pendentes || (Array.isArray(payload) && payload.length === 0)) {
        return [];
      }
      return filterPackageInMobile(payload.pendentes.sob_aprovacao);
    })
    .catch((error) => `getBidPending ${error}`);
};

export const getReleasePeding = async (orderBy = null) => {
  const order = orderBy === "" ? null : orderBy;

  return api
    .get(`/purchasers/side/pending/autopay`, {
      params: {
        order,
      },
    })
    .then((response) => response.data.payload?.pendentes?.autopay ?? [])
    .catch((error) => `getReleasePeding ${error}`);
};

export const getProposalPeding = (orderBy = null) => {
  const order = orderBy === "" ? null : orderBy;

  return api
    .get(`/purchasers/side/pending/aprovacao`, {
      params: {
        order,
      },
    })
    .then((response) => response.data.payload?.pendentes?.aprovacao ?? [])
    .catch((error) => `getProposalPeding ${error}`);
};

export const getLetterOfCreditEligibleVehiclesPending = () => {
  return api
    .get(`/purchasers/side/pending/veiculos_elegiveis`)
    .then((response) => response.data.payload?.pendentes?.veiculos_elegiveis ?? [])
    .then((vehicles) => vehicles.length > 0 ? vehicles.filter(vehicle => vehicle.qtdVeic <= 1) : [])
    .catch((error) => `getLetterOfCreditEligibleVehiclesPending ${error}`);
};

export const getBidInProgress = (activeOrderBy = null, closedOrderBy) => {
  const activeOrder = activeOrderBy === "" ? null : activeOrderBy;
  const closedOrder = closedOrderBy === "" ? null : closedOrderBy;

  return api
    .get(`/purchasers/side/ongoing/lances`, {
      params: {
        activeOrder,
        closedOrder,
      },
    })
    .then((response) => {
      const payload = response.data.payload;
      if (!payload.em_andamento || (Array.isArray(payload) && payload.length === 0)) {
        return {
          ativos: [],
          superados: [],
        };
      }

      const resultAtivos = removeDuplicateObjectApi(
        payload.em_andamento.lances.ativos,
        "ava_id"
      );
      const resultSuperados = removeDuplicateObjectApi(
        payload.em_andamento.lances.superados,
        "ava_id"
      );

      return {
        ativos: resultAtivos,
        superados: resultSuperados,
      };
    })
    .catch((error) => `getBidInProgress ${error}`);
};

export const getProposalInProgress = (activeOrderBy = null, closedOrderBy) => {
  const activeOrder = activeOrderBy === "" ? null : activeOrderBy;
  const closedOrder = closedOrderBy === "" ? null : closedOrderBy;

  return api
    .get(`/purchasers/side/ongoing/propostas`, {
      params: {
        activeOrder,
        closedOrder,
      },
    })
    .then((response) => {
      const payload = response.data.payload;
      if (!payload.em_andamento || (Array.isArray(payload) && payload.length === 0)) {
        return {
          ativas: [],
          superadas: [],
        };
      }
      return payload.em_andamento.propostas;
    })
    .then((result) => ({ ativos: result.ativas, superados: result.superadas }))
    .catch((error) => `getProposalInProgress ${error}`);
};

export const getQuotesInProgress = (activeOrderBy = null, closedOrderBy) => {
  const activeOrder = activeOrderBy === "" ? null : activeOrderBy;
  const closedOrder = closedOrderBy === "" ? null : closedOrderBy;

  return api
    .get(`/purchasers/side/ongoing/cotacoes`, {
      params: {
        activeOrder,
        closedOrder,
      },
    })
    .then((response) => {
      const payload = response.data.payload;
      if (!payload.em_andamento || (Array.isArray(payload) && payload.length === 0)) {
        return {
          ativas: [],
          superadas: [],
        };
      }
      return payload.em_andamento.cotacoes;
    })
    .then((result) => ({ ativos: result.ativas, superados: result.superadas }))
    .catch((error) => `getQuotesInProgress ${error}`);
};

export const getAutoBidInProgress = (activeOrderBy = null, closedOrderBy) => {
  const activeOrder = activeOrderBy === "" ? null : activeOrderBy;
  const closedOrder = closedOrderBy === "" ? null : closedOrderBy;

  return api
    .get(`/purchasers/side/ongoing/autobid`, {
      params: {
        activeOrder,
        closedOrder,
      },
    })
    .then((response) => {
      const payload = response.data.payload;
      if (!payload.em_andamento || (Array.isArray(payload) && payload.length === 0)) {
        return {
          ativos: [],
          superados: [],
        };
      }
      return payload.em_andamento.autobid;
    })
    .catch((error) => `getAutoBidInProgress ${error}`);
};

export const getVehiclesByIdInPackage = (id) => {
  return api
    .get(`/purchasers/packages/${id}/vehicles`)
    .then((response) => response.data.payload)
    .catch((error) => `getVehiclesByIdInPackage ${error}`);
};

export const getLotsOngoing = async (activeOrderBy = null, closedOrderBy) => {
  const activeOrder = activeOrderBy === "" ? null : activeOrderBy;
  const closedOrder = closedOrderBy === "" ? null : closedOrderBy;

  return api
    .get(`/purchasers/side/ongoing/lotes`, {
      params: {
        activeOrder,
        closedOrder,
      },
    })
    .then((response) => {
      const payload = response.data.payload;
      if (!payload.em_andamento || (Array.isArray(payload) && payload.length === 0)) {
        return {
          ativos: [],
          superados: [],
        };
      }
      return payload.em_andamento.lotes;
    })
    .catch((error) => `getLotsOngoing ${error}`);
};

export const getLotsRealized = async (orderBy = null, period) => {
  const order = orderBy === "" ? null : orderBy;

  return api
    .get(`/purchasers/side/realized/lotes`, {
      params: {
        order,
        period,
      },
    })
    .then((response) => response.data.payload?.result?.lotes ?? [])
    .catch((error) => `getLotsRealized ${error}`);
};

export const getCanceledUnfufilled = async (
  orderBy = null,
  period,
  page,
  per_page = PER_PAGE_BUYER_PAGINATION
) => {
  const order = orderBy === "" ? null : orderBy;

  return api
    .get("/purchasers/cancel", {
      params: { order, period, page, per_page },
    })
    .then((res) => res.data.payload.canceladas)
    .catch((error) => `buyer counts ${error}`);
};

export const getBidCompleted = async (
  orderBy = null,
  period = null,
  page,
  per_page = PER_PAGE_BUYER_PAGINATION
) => {
  const order = orderBy === "" ? null : orderBy;

  return api
    .get("/purchasers/side/realized/lances", {
      params: { order, period, page, per_page },
    })
    .then((res) => res.data.payload)
    .catch((error) => `buyer counts ${error}`);
};

export const getProposalCompleted = async (
  orderBy = null,
  period,
  page,
  per_page = PER_PAGE_BUYER_PAGINATION
) => {
  const order = orderBy === "" ? null : orderBy;

  return api
    .get("/purchasers/side/realized/propostas_aceitas", {
      params: { order, period, page, per_page },
    })
    .then((res) => res.data.payload)
    .catch((error) => `buyer counts ${error}`);
};

export const getQuotesCompleted = async (
  orderBy = null,
  period,
  page,
  per_page = PER_PAGE_BUYER_PAGINATION
) => {
  const order = orderBy === "" ? null : orderBy;

  return api
    .get("/purchasers/side/realized/cotacoes", {
      params: { order, period, page, per_page },
    })
    .then((res) => res.data.payload)
    .catch((error) => `buyer counts ${error}`);
};

export const getAutoBidCompleted = async (
  orderBy = null,
  period,
  page,
  per_page = PER_PAGE_BUYER_PAGINATION
) => {
  const order = orderBy === "" ? null : orderBy;

  return api
    .get("/purchasers/side/realized/autobid", {
      params: { order, period, page, per_page },
    })
    .then((res) => res.data.payload)
    .catch((error) => `buyer counts ${error}`);
};

export const getOndemandAssesmentCompleted = async (
  orderBy = null,
  period = null,
  page,
  per_page = PER_PAGE_BUYER_PAGINATION
) => {
  const order = orderBy === "" ? null : orderBy;

  return api
    .get("/purchasers/side/realized/avaliacoes_sob_aprovacao", {
      params: { order, period, page, per_page },
    })
    .then((res) => res.data.payload)
    .catch((error) => `buyer counts ${error}`);
};

export const getRealizedBuyNow = async (
  orderBy = null,
  period,
  page,
  per_page = PER_PAGE_BUYER_PAGINATION
) => {
  const order = orderBy === "" ? null : orderBy;

  return api
    .get("/purchasers/side/realized/compre_ja", {
      params: { order, period, page, per_page },
    })
    .then((res) => res.data.payload)
    .catch((error) => `buyer counts ${error}`);
};

export const getOnDemandAssessmentInProgress = (
  activeOrderBy = null,
  closedOrderBy
) => {
  const activeOrder = activeOrderBy === "" ? null : activeOrderBy;
  const closedOrder = closedOrderBy === "" ? null : closedOrderBy;

  return api
    .get("/purchasers/side/ongoing/avaliacao_sob_aprovacao", {
      params: { activeOrder, closedOrder },
    })
    .then((res) => {
      const payload = res.data.payload;
      if (!payload.em_andamento || (Array.isArray(payload) && payload.length === 0)) {
        return {
          ativos: [],
          superados: [],
        };
      }
      return payload.em_andamento.avaliacao_sob_aprovacao;
    })
    .then((result) => ({
      ativos: result.ativos ?? [],
      superados: result.superados ?? [],
    }))
    .catch((error) => `buyer counts ${error}`);
};

export const getQuotesUnfufilled = async (
  orderBy = null,
  period,
  page,
  per_page = PER_PAGE_BUYER_PAGINATION
) => {
  const order = orderBy === "" ? null : orderBy;
  return api
    .get("/purchasers/side/not-realized/cotacoes", {
      params: {
        order,
        period,
        page,
        per_page,
      },
    })
    .then((res) => res.data.payload)
    .catch((err) => `buyer counts ${err}`);
};

export const getAssessmentUnfufilled = async (
  orderBy = null,
  period,
  page,
  per_page = PER_PAGE_BUYER_PAGINATION
) => {
  const order = orderBy === "" ? null : orderBy;
  return api
    .get("/purchasers/side/not-realized/lances_superados", {
      params: {
        order,
        period,
        page,
        per_page,
      },
    })
    .then((res) => res.data.payload)
    .catch((err) => `buyer counts ${err}`);
};

export const getAutoBidUnfufilled = async (
  orderBy = null,
  period,
  page,
  per_page = PER_PAGE_BUYER_PAGINATION
) => {
  const order = orderBy === "" ? null : orderBy;
  return api
    .get("/purchasers/side/not-realized/autobid", {
      params: {
        order,
        period,
        page,
        per_page,
      },
    })
    .then((res) => res.data.payload)
    .catch((err) => `buyer counts ${err}`);
};

export const getOnDemandAssessmentdUnfufilled = async (
  orderBy = null,
  period,
  page,
  per_page = PER_PAGE_BUYER_PAGINATION
) => {
  const order = orderBy === "" ? null : orderBy;
  return api
    .get("/purchasers/side/not-realized/avaliacoes_sob_aprovacao", {
      params: {
        order,
        period,
        page,
        per_page,
      },
    })
    .then((res) => res.data.payload)
    .catch((err) => `buyer counts ${err}`);
};

export const getRejectedUnfufilled = async (
  orderBy = null,
  period,
  page,
  per_page = PER_PAGE_BUYER_PAGINATION
) => {
  const order = orderBy === "" ? null : orderBy;
  return api
    .get("/purchasers/side/not-realized/propostas_rejeitadas", {
      params: {
        order,
        period,
        page,
        per_page,
      },
    })
    .then((res) => res.data.payload)
    .catch((err) => `buyer counts ${err}`);
};

export const downloadOfTheInvoiceByCodeAndName = async (code, name) => {
  function downloadPDF(pdfBase64) {
    const link = document.createElement("a");
    link.href = "data:application/pdf;base64," + pdfBase64;
    link.download = `${name}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  if (code !== null && code !== undefined) {
    return fetch(URL.BUYER_ACTION_BUTTON_NOTA_FISCAL + code, {
      headers: {
        token: localStorage.getItem("token"),
      },
    })
      .then((res) => res.text())
      .then((data) => downloadPDF(data))
      .catch((err) => console.error("Erro ao baixar o PDF:", err));
  }
};

export const buyNow = async (id_avaliacao, value) => {
  return api
    .post(
      "/purchasers/buyNow",
      { id_avaliacao, value },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => res.data)
    .catch((err) => err);
};



